module.exports = __webpack_public_path__ + "img/10.0f5f9574.png";